/**
 * 通用资源列表跨页勾选：以 key 为唯一键合并当前页 selection 与全局已选集合。
 */

/**
 * 将当前页 el-table selection-change 结果合并进全局已选行。
 * - 当前页取消勾选的 key 从全局移除
 * - 其他页已选 key 保留
 * - 当前页新勾选用最新行对象覆盖（列表刷新后字段更准）
 *
 * @param {Array<{ key: string }>} allSelected 全局已选
 * @param {Array<{ key: string }>} pageRows 当前页全部行
 * @param {Array<{ key: string }>} pageSelected 当前页表格报告的已选行
 */
export function mergePageSelection(allSelected, pageRows, pageSelected) {
  const pageKeySet = new Set((pageRows || []).map((row) => row.key))
  const pageSelectedKeySet = new Set((pageSelected || []).map((row) => row.key))

  const kept = (allSelected || []).filter((row) => {
    if (!pageKeySet.has(row.key)) {
      return true
    }
    return pageSelectedKeySet.has(row.key)
  })

  const keptKeySet = new Set(kept.map((row) => row.key))
  ;(pageSelected || []).forEach((row) => {
    if (!keptKeySet.has(row.key)) {
      kept.push(row)
      keptKeySet.add(row.key)
      return
    }
    const index = kept.findIndex((item) => item.key === row.key)
    if (index >= 0) {
      kept[index] = row
    }
  })

  return kept
}

/** 判断 key 是否在已选集合中 */
export function isRowKeySelected(selectedRows, key) {
  if (key == null || key === '') {
    return false
  }
  return (selectedRows || []).some((row) => row.key === key)
}

/**
 * 按全局已选 key 同步当前页表格勾选 UI（分页/刷新后恢复视觉态）。
 * @param {import('vue').default['$refs']['multipleTable']} tableRef el-table 实例
 * @param {Array<{ key: string }>} pageRows
 * @param {Array<{ key: string }>} selectedRows
 */
export function syncTableRowSelection(tableRef, pageRows, selectedRows) {
  if (!tableRef || !Array.isArray(pageRows)) {
    return
  }
  const selectedKeySet = new Set((selectedRows || []).map((row) => row.key))
  pageRows.forEach((row) => {
    tableRef.toggleRowSelection(row, selectedKeySet.has(row.key))
  })
}
